import { render, staticRenderFns } from "./sider-menu.vue?vue&type=template&id=11c40509"
import script from "./sider-menu.vue?vue&type=script&lang=ts"
export * from "./sider-menu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports